import React, { useState, useEffect } from 'react';
import { Card, Col, Modal, Row, Table } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Box, Button } from 'atoms';
import { numberWithCommas } from 'utils/NumberCommaSeprator';
import { LoadingAnimation } from 'components/common';

function onNavigate(id) {
	window.location.href = `${window.origin}/trips/${id}`;
}

const CardContainer = styled(Card)`
	min-height: 300px;
	height: 100%;
	display: flex;
	align-items: center;
	overflow-x: auto;
	justify-content: center;
`;

const UnclosedTripCount = styled.div`
	font-size: 30px;
	font-weight: 500;
	font-family: Montserrat;
`;

const TitleText = styled.div`
	font-weight: 500;
	font-size: 16px;
`;

const ViewMore = styled(Button)`
	color: #ee6055;
	float: right;
	background: #fff6f5;
`;

const columns = [
	{
		title: 'Trip ID',
		dataIndex: 'id',
		key: 'id',
	},
	{
		title: 'Days',
		dataIndex: 'duration',
		key: 'duration',
	},
	{
		title: 'City',
		dataIndex: 'city',
		key: 'city',
	},
	{
		title: 'Actions',
		dataIndex: 'id',
		key: 'id',
		render: (id) =>
			id && (
				<Box
					onClick={() => onNavigate(id)}
					style={{
						color: '#1890ff',
						cursor: 'pointer',
					}}
				>
					<EyeOutlined />
				</Box>
			),
	},
];

function UnclosedTrips({ unclosed, isLoading }) {
	const [modalVisible, setModalVisible] = useState(false);
	const unclosedCount = unclosed?.unclosed_trips_count || 0;
	const [tripList, setTripList] = useState();
	const [fullTripList, setFullTripList] = useState();

	const showModal = () => {
		setModalVisible(true);
	};

	const handleCancel = () => {
		setModalVisible(false);
	};

	useEffect(() => {
		if (unclosed && unclosed?.unclosed_trips_data) {
			const updated = [...unclosed.unclosed_trips_data];
			const updatedArray = updated.map((item) => {
				const durationInDays = moment.duration(item.duration, 'hours').asDays();
				item.duration = Math.trunc(durationInDays);
				return item;
			});
			setFullTripList(updatedArray);
			setTripList(updatedArray.slice(0, 3));
		} else {
			setTripList(null);
		}
	}, [unclosed]);

	return (
		<CardContainer>
			{isLoading ? (
				<LoadingAnimation visible={isLoading} animationID="UnclosedTripsLoader" />
			) : (
				// eslint-disable-next-line react/jsx-no-useless-fragment
				<>
					<Row align="stretch">
						<Col xs={24} sm={24}>
							<Row align="middle" justify="space-between">
								{unclosedCount > 0 ? (
									<Col xs={24} sm={12} md={12}>
										<TitleText>Unclosed Trips</TitleText>
										<UnclosedTripCount>
											{numberWithCommas(unclosedCount)}
										</UnclosedTripCount>
									</Col>
								) : (
									<Col xs={24}>
										<TitleText>Unclosed Trips</TitleText>
										<UnclosedTripCount style={{ textAlign: 'center' }}>
											{numberWithCommas(unclosedCount)}
										</UnclosedTripCount>
									</Col>
								)}
								<Col xs={24} sm={12} md={12}>
									{unclosedCount > 0 && (
										<>
											<ViewMore onClick={showModal}>
												View More
												<EyeOutlined style={{ marginLeft: '10px' }} />
											</ViewMore>
											<Modal
												title="Unclosed Trips"
												open={modalVisible}
												onCancel={handleCancel}
												footer={null}
												bodyStyle={{ maxHeight: '500px', overflow: 'auto' }}
											>
												<Table
													dataSource={fullTripList}
													columns={columns}
													pagination={false}
													scroll={{ y: 240 }}
												/>
											</Modal>
										</>
									)}
								</Col>
							</Row>
						</Col>
						{unclosedCount > 0 && (
							<Col className="mt-15" xs={24} sm={24}>
								<Table pagination={false} dataSource={tripList} columns={columns} />
							</Col>
						)}
					</Row>
				</>
			)}
		</CardContainer>
	);
}

UnclosedTrips.propTypes = {
	unclosed: PropTypes.object,
	isLoading: PropTypes.bool,
};

export default UnclosedTrips;
